module.exports = require("osnova");


//////////////////
// WEBPACK FOOTER
// external "osnova"
// module id = 3
// module chunks = 0